import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Header } from "./components/header";

import { Contact } from "./components/contact";
import { PreFooter } from "./components/prefooter";
import footerData from "./data/footer-data.json";

import Home from "./pages/Home";
import ContactPage from "./pages/Contact";
import CikPage from "./pages/Colocation-in-Knoxville";
import PspPage from "./pages/per-server-space";
import VhpPage from "./pages/vps-hosting-plans";
import DpspPage from "./pages/dedicated-proxmox-server-plans";
import PbpPage from "./pages/proxmox-backup-plans";

import JsonData from "./data/data.json";
import headerData from "./data/header-data.json";

import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <Router>
      <Header data={headerData.Navigation} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/colocation-in-koxville" element={<CikPage />} />
        <Route path="/per-server-space" element={<PspPage />} />
        <Route path="/vps-hosting-plans" element={<VhpPage />} />
        <Route path="/dedicated-proxmox-server-plans" element={<DpspPage />} />
        <Route path="/proxmox-backup-plans" element={<PbpPage />} />
      </Routes>
      <PreFooter data={footerData.prefooter} />
      <Contact data={landingPageData.Contact} />
    </Router>
    
  );
};

export default App;
